import { NegotiationPaymentMethod } from "../../../shared/services/api/sinister/SinisterNegotiationService";

// Cartão de crédito removido temporariamente (integração com o módulo de cartão suspensa) —
// se voltar a ficar disponível, reintroduzir { value: "credit_card", label: "Cartão de Crédito" }.
export const PAYMENT_METHOD_OPTIONS: { value: NegotiationPaymentMethod; label: string }[] = [
	{ value: "boleto", label: "Boleto Bancário" },
	{ value: "pix", label: "Pix" },
];

export const getPaymentMethodLabel = (method: NegotiationPaymentMethod | string): string =>
	PAYMENT_METHOD_OPTIONS.find((option) => option.value === method)?.label ?? method;
